import { Component, Input, OnChanges, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Form, Frequency } from '@vendasta/galaxy/frequency';
import { PricingRule } from '@vendasta/marketplace-apps';
import { convertCentsToDollars } from '@vendasta/shared';
import { baseTranslationKey, freeTranslationKey } from '../simple-price-display.component';
import { StairstepDialogComponent } from './stairstep-dialog/stairstep-dialog.component';

@Component({
  selector: 'billing-ui-stairstep-price-display',
  templateUrl: './stairstep-price-display.component.html',
  styleUrls: ['./stairstep-price-display.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StairstepPriceDisplayComponent implements OnChanges, OnInit {
  @Input() stairsteps: PricingRule[] = [];
  @Input() currencyCode = 'USD';
  @Input() align: 'start' | 'end' | 'center' = 'start';
  @Input() form: Form = Form.SHORT;
  @Input() size: 'regular' | 'large' = 'regular';
  @Input() frequency: Frequency;
  Frequency = Frequency;
  Form = Form;
  freeLabel: string;
  dialogStairsteps: Map<string, PricingRule>;
  shouldShowDialogLink: boolean;

  ngOnChanges(): void {
    // We do the calculations after making sure the stairsteps are correctly subscribed by the parent component
    if (this.stairsteps?.length === 0 || !this.frequency) {
      return;
    }

    this.dialogStairsteps = new Map<string, PricingRule>();

    this.stairsteps.forEach((step) => {
      this.dialogStairsteps.set(this.generateTopInfo(step), step);
    });

    if (this.stairsteps.length > 3 && this.size.toLowerCase() === 'large') {
      this.shouldShowDialogLink = true;
      this.stairsteps = this.stairsteps.slice(0, 3);
    } else {
      this.shouldShowDialogLink = false;
    }
  }

  constructor(
    private translateService: TranslateService,
    public dialog: MatDialog,
  ) {}
  ngOnInit(): void {
    this.loadTranslations();
  }

  loadTranslations(): void {
    this.freeLabel = this.translateService.instant(`${baseTranslationKey}${freeTranslationKey}`);
  }

  centsToDollars(value: number): number {
    return convertCentsToDollars(value);
  }

  generateTopInfo(step: PricingRule): string {
    const min = step.min;
    const max = step.max;
    let topInfo = min + '';
    const equalSteps = min === max;
    const infiniteMax = max === -1;

    if (min === 1 && equalSteps) {
      topInfo += ' account';
    } else if (min > 1 && equalSteps) {
      topInfo += ' accounts';
    } else {
      if (infiniteMax) {
        topInfo += '+';
      } else {
        topInfo += '-' + max;
      }
      topInfo += ' accounts';
    }

    return topInfo;
  }

  openStepsDialog(): void {
    // Make sure the stairstep are refresh when coming from sandbox
    const tempStairsteps = new Map<string, PricingRule>();

    for (const entry of this.dialogStairsteps.entries()) {
      tempStairsteps.set(this.generateTopInfo(entry[1]), entry[1]);
    }

    this.dialog.open(StairstepDialogComponent, {
      width: '433px',
      data: {
        stairsteps: tempStairsteps,
        currencyCode: this.currencyCode,
        frequency: this.frequency,
        freeLabel: this.freeLabel,
      },
    });
  }
}
